import axios from 'axios';

export default {
    getStudyData(pageNumber, pagination, filters = null) {
        let filter_string = '';
        if (pageNumber && pagination) {
            filter_string = '?PageNumber=' + pageNumber + '&PageSize=' + pagination;
        }

        if (filters !== null) {
            filter_string = '?' + filters;
            if (pageNumber && pagination) {
                filter_string += '&PageNumber=' + pageNumber + '&PageSize=' + pagination;
            }

        }
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study' + filter_string;
        return axios.get(url
        ).then((response) => {
            return response.data;
        })
            .catch((error) => {
                console.log(error);
            });
    },

    getStudyDataById(id) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/' + id;
        return axios.get(url
        ).then((response) => {
            return response.data;
        })
            .catch((error) => {
                console.log(error);
            });
    },

    getStudyImagesById(id, start = null, end = null) {

        let url = 'https://sdy.spx.dotnet.vecto.it/api/Study/' + id + '/images';
        if (start !== null && end !== null) {
            url += '?from=' + start + '&to=' + end;

        }

        return axios.get(url
        ).then((response) => {
            return response.data;
        })
            .catch((error) => {
                console.log(error);
            });
    },

    addStudy(credentials) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study';
        return axios({
            method: 'post',
            url: url,
            data: credentials,
            headers: {'Content-Type': 'multipart/form-data'}
        })
            .then((response) => {
                if (response.status == 200) {
                    response.data.sort(function(a, b){return b.id-a.id});
                    return response.data;
                } else {
                    return response.response.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    },

    deleteStudy(id) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/' + id;
        return axios.delete(url)
            .then(response => response.data)
            .catch((error) => {
                console.log(error);
            });
    },

    editStudy(id, credentials) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/' + id;
        return axios.put(url, credentials)
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    return response.response.data;
                }
            })
            .catch((error) => {
                console.log(error);
            })
    },

    editVeinsById(studyId, id, credentials) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/' + studyId + '/vein/' + id;
        return axios.put(url, credentials)
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    return response.response.data;
                }
            })
            .catch((error) => {
                console.log(error);
            })
    },

    deleteStudyImage(StudyId, FileName) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/remove-study-image';
        const config = {headers: {'Content-Type': 'multipart/form-data'}};
        const formData = new FormData();
        formData.append('StudyId', StudyId);
        formData.append('FileName', FileName);
        return axios.delete(url, {data: formData, config})
            .then(response => response.data)
            .catch((error) => {
                console.log(error);
            });
    },

    addNote(credentials) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/exam/note';
        return axios({
            method: 'post',
            url: url,
            data: credentials
        })
            .then((response) => {
                if (response.status == 201) {
                    return response.data;
                } else {
                    return response.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    },

    editNote(credentials) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/exam/note';
        return axios({
            method: 'put',
            url: url,
            data: credentials
        })
            .then((response) => {
                console.log(response);
                if (response.status == 201) {
                    return response.data;
                } else {
                    return response.response.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    },

    deleteNote(id) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/exam/note/' + id;
        return axios.delete(url)
            .then(response => response.data)
            .catch((error) => {
                console.log(error);
            });
    },

    getVeinNote(studyId) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/vein/note/' + studyId;
        return axios.get(url
        ).then((response) => {
            return response.data;
        })
            .catch((error) => {
                console.log(error);
            });

    },

    addVeinNote(credentials) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/vein/note';
        return axios({
            method: 'post',
            url: url,
            data: credentials
        })
            .then((response) => {
                console.log(response);
                if (response.status == 201) {
                    return response.data;
                } else {
                    return response.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    },

    editVeinNote(credentials) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/vein/note';
        return axios({
            method: 'put',
            url: url,
            data: credentials
        })
            .then((response) => {
                console.log(response);
                if (response.status == 201) {
                    return response.data;
                } else {
                    return response.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    },

    deleteVeinNote(id) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/vein/note/' + id;
        return axios.delete(url)
            .then(response => response.data)
            .catch((error) => {
                console.log(error);
            });
    },

    getStudyReports(studyId, start = null, end = null) {
        let url = 'https://sdy.spx.dotnet.vecto.it/api/Report/' + studyId + '/reports';
        if (start !== null && end !== null) {
            url += '?from=' + start + '&to=' + end;
        }
        return axios.get(url
        ).then((response) => {
            return response.data;
        })
            .catch((error) => {
                console.log(error);
            });
    },

    getStudyReportsById(id) {
        let url = 'https://sdy.spx.dotnet.vecto.it/api/Report/' + id;
        const config = {responseType: 'blob'};
        return axios.get(url, config
        ).then((response) => {
            const file = new Blob(
                [response.data],
                {type: 'application/pdf'});
            const fileURL = URL.createObjectURL(file);
            return fileURL;
        })
            .catch((error) => {
                console.log(error);
            });
    },

    deleteStudyReport(id) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Report/' + id;
        return axios.delete(url)
            .then(response => response.data)
            .catch((error) => {
                console.log(error);
            });
    },

    getDashboardStatistics() {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Statistic';
        return axios.get(url
        ).then((response) => {
            return response.data;
        })
            .catch((error) => {
                console.log(error);
            });
    },

    getVeinSvg (credentials) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/vein/image'

        return axios.get(url + '?' + credentials)
            .then((response) => {
                if (response.status == 200) {
                    return response;
                } else {
                    return response.data;
                }
            })
            .catch((error) => {
                console.log(error);

            })
    },

    editVeinSvg(id, credentials) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/vein/image/' +id;
        return axios({
            method: 'put',
            url: url,
            data: credentials,
            headers: {'Content-Type': 'multipart/form-data' }
        })
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    return response.response.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    },

    saveVeinSvg(credentials) {
        const url = 'https://sdy.spx.dotnet.vecto.it/api/Study/vein/image';
        return axios({
            method: 'post',
            url: url,
            data: credentials,
            headers: {'Content-Type': 'multipart/form-data' }
        })
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    return response.response.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

}
